import EntityFlagImage from './EntityFlagImage';
import { cn } from '../utils/cn';

export function TeamLabel({ team, flagSize = 'sm', className }) {
  if (!team || team.mode === 'none' || !team.name) return null;

  return (
    <span className={cn('inline-flex items-center gap-1.5', className)}>
      {team.flagUrl && <EntityFlagImage src={team.flagUrl} alt={team.name} size={flagSize} />}
      {team.mode === 'custom' && team.emoji && (
        <span aria-hidden="true">{team.emoji}</span>
      )}
      <span>{team.name}</span>
    </span>
  );
}
